import { OrganizationData } from "../../models/OrganizationData";

const API_URL = `${process.env.REACT_APP_API_URL}/api/OutlookAdmin/GetOrganizationInfo`;

export const fetchOrganizationInfo = async (accessToken: string, email: string, TenantId: number): Promise<OrganizationData> => {
  try {
    const response = await fetch(`${API_URL}?userMail=${encodeURIComponent(email)}&tenantId=${TenantId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch organization info.");
    }

    const data: OrganizationData = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
